import React, {useState} from 'react'
import {AppContainer} from '../../../_metronic/helpers/components/AppContainer'
import './index.css'
import {FiUpload} from 'react-icons/fi'
import PrivateRequest from '../api/PrivateRequest'
import toast, { Toaster } from 'react-hot-toast';

const RequestUp = () => {
  const [File, setFileSelected] = useState<string>('')
  const [showImage, setShowImage] = useState<boolean>(false)
  const [ImageFile, setImageFile] = useState<string>('')
  const [title, setTitle] = useState<string>()
  const [desparteman, setDeparteman] = useState<string>()
  const [description, setDescription] = useState<string>()
  const [Loading, setloading] = useState<boolean>(false)


  const handleUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (setFileSelected) {
      const formData = new FormData()
      formData.append('image', setFileSelected.name)
      setShowImage(true)
    }
    console.log('e.target.value:')
    console.log(e.target.files)
    console.log(ImageFile)
  }

  const SubmitForm = () => {
    setloading(true)
    PrivateRequest().post('userrequest', {
      title: title,
      departeman: desparteman,
      description: description
    }).then((res) => {
      toast.success(res.data.msg)
      setloading(false)
      console.log('res req user', res)
    }).catch((err) => {
      setloading(false)
      toast.error(err.response.data.msg)
      console.log('res', err.response.data.msg)
    })
  }
  

  return (
    <div>
      <AppContainer title={'درخواست جدید '}>
        <Toaster />
        <h5 className={'text-right text-2xl	 font-bold  titleRequest pr-2 '}>ثبت درخواست جدید</h5>
        <div className='container'>
          <div className='form w-100 fv-plugins-bootstrap5 fv-plugins-framework Request mt-14'>
            <div className=' row fv-row mb-8 '>
              <div className='col-lg-5'>
                <div className='selectedDepartment'>
                  <label className='form-label font-medium text-xl leading-7  flex justify-end md'>
                    انتخاب دپارتمان
                  </label>
                  <select
                    dir={'rtl'}
                    onChange={(e:any) => setDeparteman(e.target.value)}
                    name='department'
                    id='department'
                    className='w-full appearance-none border-0 p-4'
                  >
                    <option value='' selected disabled>
                      انتخاب کنید..
                    </option>
                    <option value='مدیریت بیمارستان' className='others'>
                      مدیریت بیمارستان
                    </option>
                    <option value='معاونت بیمارستان' className='others'>
                      معاونت بیمارستان
                    </option>
                    <option value='کارشناس فروس' className='others'>
                      کارشناس فروش
                    </option>
                  </select>
                </div>
              </div>
              <div className='col-lg-7'>
                <label className='form-label font-medium text-xl leading-7 flex justify-end'>
                  موضوع درخواست
                </label>
                <input
                  dir={'rtl'}
                  type='text'
                  id='subject'
                  onChange={(e:any) => setTitle(e.target.value)}
                  name='subject'
                  className='subject w-full appearance-none border-0  p-4'
                  placeholder=' لطفا یک موضوع برای درخواست خود وارد نمایید    '
                />
              </div>
            </div>

            <div className='row fv-row'>
              <div className='col-12'>
                <label className='form-label font-medium text-xl leading-7  flex justify-end'>
                  شرح درخواست
                </label>
                <textarea
                  name='description'
                  className=' form-control block w-full px-8 text-base font-normal'
                  dir={'rtl'}
                  onChange={(e:any) => setDescription(e.target.value)}
                  id='description'
                  rows={8}
                  cols={16}
                  placeholder='لطفا درخواست خود را وارد نمایید '
                />
                <div className='flex '>
                  <div className=''>
                    {/*<div className='file-upload flex '>*/}
                    {/*  <div className='file-select flex items-basline  mr-5 uploadFile '>*/}
                    {/*    <FiUpload size={'15px'} className='mr-4 uploadIcon' />*/}
                    {/*    <label*/}
                    {/*      className='form-label font-medium text-xl leading-7 flex justify-end'*/}
                    {/*      htmlFor='chooseFile'*/}
                    {/*    >*/}
                    {/*      آپلود فایل*/}
                    {/*    </label>*/}
                    {/*    <input*/}
                    {/*      type='file'*/}
                    {/*      dir={'rtl'}*/}
                    {/*      hidden*/}
                    {/*      className=' text-white font-bold text-base leading-6 mb-14 flex items-center'*/}
                    {/*      accept='image/png, image/jpeg ,.doc,.docx,.pdf'*/}
                    {/*      name='chooseFile'*/}
                    {/*      id='chooseFile'*/}
                    {/*      onChange={handleUpload}*/}
                    {/*    />*/}
                    {/*  </div>*/}

                    {/*  <div*/}
                    {/*    className={*/}
                    {/*      showImage ? `file-select flex item-center  flex-row-reverse ` : ` hidden`*/}
                    {/*    }*/}
                    {/*  >*/}
                    {/*    <label*/}
                    {/*      className='form-label font-medium text-xl leading-7 flex justify-end imgUpload'*/}
                    {/*      htmlFor='chooseFile'*/}
                    {/*    >*/}
                    {/*      form.pdf*/}
                    {/*    </label>*/}
                    {/*  </div>*/}
                    {/*</div>*/}
                  </div>
                </div>
              </div>
            </div>

            <div className='row fv-row mt-5 '>
              <div className='col-12'>
                <div className=' submitRequest'>
                  <button onClick={SubmitForm} type='submit' className=' text-2xl font-extrabold	 text-white	'>
                    {!Loading ? (
                      ' ثبت درخواست'
                    ): (
                      'در حال ثبت درخواست'
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </AppContainer>
    </div>
  )
}

export default RequestUp
